exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disdiv[data-v-00a9a8f4],.disitem[data-v-00a9a8f4]{opacity:.4!important}.disdiv[data-v-00a9a8f4]{pointer-events:none}", ""]);

// exports
